import { Col, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import StatusSelectField from 'components/forms/domain/property/StatusSelectField';
import TagsMultiSelectField from 'components/forms/domain/property/TagsMultiSelectField';
import {
  FilterFormActions,
  FilterFormClearButton,
} from 'components/filters/FilterFormButtons';
import { MultiSelectOption } from 'utils/property/getPropertiesQuery';

export interface PropertiesFilterValues {
  status: string;
  tags: MultiSelectOption[];
}

const PropertiesFilter = ({ onClear }: { onClear: () => void }) => {
  const { reset, watch } = useFormContext();
  const isPropertiesSearchActive = !!watch('propertySearch')?.length;

  const handleClear = () => {
    reset();
    onClear();
  };

  return (
    <div>
      <Row>
        <Col md={6} sm={12}>
          <StatusSelectField
            name="status"
            disabled={isPropertiesSearchActive}
          />
        </Col>
        <Col md={6} sm={12}>
          <TagsMultiSelectField
            name="tags"
            disabled={isPropertiesSearchActive}
          />
        </Col>
      </Row>

      <FilterFormActions>
        <FilterFormClearButton onClick={handleClear} />
      </FilterFormActions>
    </div>
  );
};

export default PropertiesFilter;
